import { createContext, useContext } from "react";

import cuid from "cuid";
import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node,
};

const HomePageContext = createContext({});

const useHomePage = () => {
  return useContext(HomePageContext);
};

const useHomePageId = () => {
  return useHomePage()?.homePageId || null;
};

const HomePageProvider = ({ children }) => {
  const contextData = {
    homePageId: cuid(),
    isHomePage: true,
  };
  return (
    <HomePageContext.Provider value={contextData}>
      {children}
    </HomePageContext.Provider>
  );
};

HomePageProvider.propTypes = propTypes;

export default useHomePage;
export { HomePageContext, HomePageProvider, useHomePageId };
